/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {uploadBrandHeroImage} from '../api'

export const useMutationUploadBrandHeroImage = createReactQueryMutationHook('uploadBrandHeroImage', uploadBrandHeroImage)
